import { useNavigate, useLocation } from 'react-router-dom';
import { FiShield, FiArrowLeft, FiMessageCircle } from 'react-icons/fi';
import { useAuthStore, useSettingsStore } from '../../store';
import { ROUTES } from '../../utils';
import './AccessDenied.css';

const moduleLabels = {
  '/dashboard': 'Panel',
  '/customers': 'Clientes',
  '/vehicles': 'Vehículos',
  '/workorders': 'Órdenes',
  '/workload': 'Carga de Trabajo',
  '/services': 'Servicios',
  '/inventory': 'Inventario',
  '/calendar': 'Calendario',
  '/quotes': 'Cotizaciones',
  '/parts-report': 'Repuestos',
  '/reminders': 'Recordatorios',
  '/inspections': 'Inspecciones',
};

const roleLabels = {
  superadmin: 'Super Admin',
  admin: 'Administrador',
  technician: 'Mecánico',
};

function AccessDenied() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();
  const { settings } = useSettingsStore();

  const fallback = ['admin', 'superadmin'].includes(user?.role)
    ? ROUTES.DASHBOARD
    : '/workorders';

  const currentPath = '/' + location.pathname.split('/')[1];
  const moduleName = moduleLabels[currentPath] || location.pathname;
  const roleName = roleLabels[user?.role] || user?.role;

  const whatsappMessage = encodeURIComponent(
    `Hola ConsolTech, soy ${user?.name || 'usuario'} (rol: ${roleName}) del taller "${settings?.name || 'mi taller'}". Estoy intentando acceder al módulo "${moduleName}" pero me indica que no tengo acceso. ¿Podrían ayudarme?`
  );
  const whatsappUrl = `https://wa.me/50368960231?text=${whatsappMessage}`;

  return (
    <div className="container-accessdenied">
      <div className="card-accessdenied">
        <div className="icon-wrapper-accessdenied">
          <div className="icon-bg-accessdenied">
            <FiShield className="icon-accessdenied" />
          </div>
        </div>
        <h1 className="title-accessdenied">Acceso No Permitido</h1>
        <p className="message-accessdenied">
          Este módulo no está disponible para tu taller.
        </p>
        <p className="hint-accessdenied">
          Si crees que esto es un error, contacta a ConsolTech para obtener ayuda.
        </p>
        <div className="actions-accessdenied">
          <button
            className="button-accessdenied"
            onClick={() => navigate(fallback, { replace: true })}
          >
            <FiArrowLeft />
            <span>Volver al inicio</span>
          </button>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="button-whatsapp-accessdenied"
          >
            <FiMessageCircle />
            <span>Contactar soporte</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
